import { api } from "./config/api";
import { REPORTS_API_URL } from "./config/constants";
import { Pedido, RelatorioFiltro, RelatorioTotaisPorStatusMesAno } from "./models";

const getOrderMonthlyReport = async (start_date?: Date, end_date?: Date) => {
    const currentDate = new Date()
    start_date = start_date || new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    end_date = end_date || currentDate

    const { data } = await api
        .post<RelatorioTotaisPorStatusMesAno[]>(`${REPORTS_API_URL}/TotaisPorStatusMesAno`, {
            d_data_inicio: start_date?.toISOString(),
            d_data_fim: end_date?.toISOString(),
            b_agrupa_por_mes_ano: true
        } as RelatorioFiltro)
    return data
}

export { getOrderMonthlyReport }